/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SessionEventDTO
 */
export interface SessionEventDTO {
    /**
     * 
     * @type {string}
     * @memberof SessionEventDTO
     */
    eventBody: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEventDTO
     */
    eventType: string;
}

/**
 * Check if a given object implements the SessionEventDTO interface.
 */
export function instanceOfSessionEventDTO(value: object): value is SessionEventDTO {
    if (!('eventBody' in value) || value['eventBody'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    return true;
}

export function SessionEventDTOFromJSON(json: any): SessionEventDTO {
    return SessionEventDTOFromJSONTyped(json, false);
}

export function SessionEventDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionEventDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'eventBody': json['eventBody'],
        'eventType': json['eventType'],
    };
}

export function SessionEventDTOToJSON(value?: SessionEventDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'eventBody': value['eventBody'],
        'eventType': value['eventType'],
    };
}

